module.exports = __webpack_public_path__ + "static/media/ATS-V2-multi.baea992f.jpg";